import { forwardRef } from 'react'
import type { SelectHTMLAttributes } from 'react'
import { cx } from '../../cx'
import styles from './Select.module.css'

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  /** Skrót na aria-invalid — ramka w kolorze --k1-danger przez CSS. */
  invalid?: boolean
  /**
   * `field` — pole formularza na całą szerokość; `filter` — płaska pigułka
   * filtra listy ze spec 01 (komponent 7), szeroka na treść (fala 9, grupa 114).
   */
  variant?: 'field' | 'filter'
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { invalid, variant = 'field', className, children, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      {...rest}
      aria-invalid={invalid ?? rest['aria-invalid']}
      className={cx(styles.select, variant === 'filter' && styles.filter, className)}
    >
      {children}
    </select>
  )
})
